import React, { useMemo } from 'react';
import ReactModal from 'react-modal';
import './QuickViewModal.less';

export const QuickViewModal = ({
  isOpen,
  onRequestClose,
  contentLabel,
  contentElement,
  children,
  shouldCloseOnOverlayClick,
}) => {
  const derivedAppElement = useMemo(() => {
    if (typeof document === 'undefined') return undefined;
    const candidates = [
      document.querySelector('#root'),
      document.querySelector('#app'),
      document.querySelector('[data-app-root]'),
      document.querySelector('main,[role="main"]'),
    ].filter(Boolean);
    const el = candidates.find((el) => el && el !== document.body);
    return el;
  }, []);
  return (
    <ReactModal
      isOpen={!!isOpen}
      onRequestClose={onRequestClose}
      contentLabel={contentLabel}
      className={'quick-view-modal__content'}
      overlayClassName={'quick-view-modal'}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      closeTimeoutMS={200}
      appElement={derivedAppElement}
      ariaHideApp={!!derivedAppElement}
      contentElement={contentElement}
    >
      <div className="quick-view-close-wrap">
        <button type="button" onClick={onRequestClose} aria-label="Close" className="quick-view-close">
          <i className="le-icon-x"></i>
        </button>
      </div>

      <div className="d-flex quick-view-modal__body">{children}</div>
    </ReactModal>
  );
};
